<template>
    <div>
        <div>
            <v-btn
                class="mx-4"
                small
                depressed
                color="primary"
                outlined
                @click="billingDialog = true"
            >
                <v-icon>
                    mdi-wallet-outline
                </v-icon>
            </v-btn>
            <v-btn
                class="mx-4"
                small
                depressed
                color="primary"
                outlined
                @click="historyDialog = true"
            >
                <v-icon>
                    mdi-clipboard-text-clock-outline
                </v-icon>
            </v-btn>
            <v-btn
                class="mx-4"
                small
                depressed
                color="primary"
                outlined
                @click="invoiceDialog = true"
            >
                <v-icon>
                    mdi-cash-multiple
                </v-icon>
            </v-btn>
        </div>
        <v-dialog v-model="billingDialog" max-width="700px">
            <v-card class="pa-2">
                <v-card-title class="d-flex justify-center mb-4">
                    <v-icon left>
                        mdi-wallet-outline
                    </v-icon>
                    <h3 class="font-weight-light text-capitalize">Facturación</h3>
                </v-card-title>
                <v-card-text>
                    <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-around' : 'text-center'">
                        <h5 class="font-weight-light grey--text">
                            <strong>Operaciones Pendientes:</strong>
                            <v-icon
                                :color="billingInfo.hasPendingOperations ? 'red' : 'green'"
                            >
                                {{ billingInfo.hasPendingOperations ? 'mdi-alert-circle' : 'mdi-check-circle' }}
                            </v-icon>
                        </h5>
                        <h5 class="font-weight-light grey--text">
                            <strong>Estado:</strong>
                            <v-icon
                                :color="billingInfo.status == 'ACTIVATED' ? 'green' : 'red'"
                            >
                                {{ billingInfo.status == 'ACTIVATED' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                            </v-icon>
                        </h5>
                        <AgentUserInfo :expeditionUserInfo="billingInfo.billingUserInfo" :title="'Información del Usuario de Facturación'"/>
                    </div>
                    <div class="text-center">
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Facturación</strong></h3>
                        <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                            <div class="text-left">
                                <h4 class="font-weight-light grey--text"><strong>Ciclo de facturación:</strong> {{ billingInfo.billingInfo.billingCycle }}</h4>
                                <h4 class="font-weight-light grey--text"><strong>Tipo:</strong> {{ billingInfo.billingInfo.type }}</h4>
                                <h4 class="font-weight-light grey--text"><strong>Número de cargo:</strong> {{ formatChargingNumber(billingInfo.billingInfo.chargingNumber) }}</h4>
                                <h4 class="font-weight-light grey--text"><strong>Formato de factura:</strong> {{ billingInfo.billingInfo.invoiceFormat }}</h4>
                                <h4 class="font-weight-light grey--text"><strong>¿Pendiente?:</strong>
                                    <v-icon
                                        small
                                        :color="billingInfo.billingInfo.isPending ? 'red' : 'green'"
                                    >
                                        {{ billingInfo.billingInfo.isPending ? 'mdi-alert-circle' : 'mdi-check-circle' }}
                                    </v-icon>
                                </h4>
                                <h4 class="font-weight-light grey--text"><strong>Última fecha de facturación:</strong> {{ billingInfo.billingInfo.lastBillingDate }}</h4>
                            </div>
                            <div class="text-left">
                                <h4 class="font-weight-light grey--text"><strong>Próxima fecha de facturación:</strong> {{ billingInfo.billingInfo.nextBillingDate }}</h4>
                                <h4 class="font-weight-light grey--text"><strong>Método de pago:</strong> {{ billingInfo.billingInfo.paymentMethod }}</h4>
                                <h4 class="font-weight-light grey--text"><strong>Saldo Gastado:</strong> {{ billingInfo.billingInfo.spendBalance }} €</h4>
                                <h4 class="font-weight-light grey--text"><strong>Saldo Total:</strong> {{ billingInfo.billingInfo.totalBalance }} €</h4>
                                <h4 class="font-weight-light grey--text"><strong>Impagos:</strong> {{ billingInfo.billingInfo.unpaidInvoices }}</h4>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        text
                        @click="billingDialog = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="historyDialog" max-width="500px">
            <v-card class="pa-2">
                <v-card-title class="d-flex justify-center mb-4">
                    <v-icon left>
                        mdi-clipboard-text-clock-outline
                    </v-icon>
                    <h3 class="font-weight-light text-capitalize">Historial de Estado</h3>
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        dense
                        :headers="historyHeaders"
                        :items="billingInfo.statusHistoryInfo"
                    >
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        text
                        @click="historyDialog = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="invoiceDialog" max-width="1000px">
            <v-card class="">
                <v-card-title class="d-flex justify-center mb-4">
                    <v-icon left>
                        mdi-cash-multiple
                    </v-icon>
                    <h3 class="font-weight-light text-capitalize">Facturas</h3>
                </v-card-title>
                <v-card-text class="d-flex justify-center flex-wrap">
                    <v-card v-for="invoice in orderedInvoices" :key="invoice.id" class="ma-2 pa-2" :width="!$vuetify.breakpoint.smAndDown ? '47%' : '100%'">
                        <v-card-title class="d-flex justify-space-between mx-4">
                            <h5 class="font-weight-light primary--text">Factura del {{ invoice.date }}</h5>
                            <div class="d-flex flex-column text-center">
                                <v-btn
                                    depressed
                                    color="primary"
                                    class="font-weight-light"
                                >
                                    {{ invoice.totalPay }} €
                                </v-btn>
                                <span class="font-weight-light grey--text" style="font-size: 12px;">
                                    {{ getTaxesData(invoice) }}
                                </span>
                            </div>
                        </v-card-title>
                        <v-card-text :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-around' : 'text-center'">
                            <div class="d-flex align-center">
                                <h4 class="font-weight-light">Estado</h4>
                                <v-icon
                                    class="ml-2"
                                    right
                                    :small="$vuetify.breakpoint.smAndDown"
                                    :color="invoice.status === 'PAID' ? 'green' : 'red'"
                                >
                                    mdi-circle
                                </v-icon>
                            </div>
                            <div class="d-flex align-center">
                                <h4 class="font-weight-light"><strong>Fecha de Pago: </strong></h4>
                                <h4 class="font-weight-light mx-1">{{ formatDateYYYYMMDD(invoice.payDate) }}</h4>
                            </div>
                            <div class="d-flex align-center" @click="getInvoicePDF(invoice.pdfId)" style="cursor: pointer;">
                                <h4 class="font-weight-light">PDF</h4>
                                <v-icon
                                    class="ml-2"
                                    right
                                    :small="$vuetify.breakpoint.smAndDown"
                                    :color="invoice.pdfId ? 'red' : 'grey'"
                                >
                                    mdi-file-pdf-box
                                </v-icon>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        text
                        @click="invoiceDialog = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AgentUserInfo from './AgentUserInfo.vue';
import { formatDateYYYYMMDD } from '@/util/libUtil.js';
import { mapActions } from 'vuex';

export default {
    data: () => ({
        billingDialog: false,
        historyDialog: false,
        invoiceDialog: false,
        historyHeaders: [
            {
                text: 'Fecha de Modificación',
                value: 'modificationDate',
            },
            {
                text: 'Estado',
                value: 'status',
            },
        ],
    }),
    components: {
        AgentUserInfo,
    },
    props: {
        billingInfo: {
            type: Object,
            required: true,
        },
        invoices: {
            type: Array,
        },
    },
    computed: {
        orderedInvoices() {
            return this.invoices.sort((a, b) => {
                return new Date(b.date) - new Date(a.date);
            });
        },
    },
    methods: {
        formatDateYYYYMMDD,
        getInvoicePDF(pdfId) {
            if (!pdfId) return;
            return this.$store.dispatch('agent/agentInvoice', pdfId);
        },
        formatChargingNumber(chargingNumber) {
            const last = chargingNumber.slice(-4);
            return `**** **** **** ${last}`;
        },
        getTaxesData(taxes) {
            const totalWithoutTax = parseFloat(taxes.totalWithoutTax.replace(',', '.'));
            const tax = parseFloat(taxes.tax.replace(',', '.'));

            return `${totalWithoutTax} € + ${tax} €`;
        },
        ...mapActions('agent', ['agentInvoice']),
    }
};
</script>